<template>
    <div>

        <!-- Lazyloading - Detect View Area -->
        <lazy-component @show="lazy_handler()"></lazy-component>

        <div v-if="alerts.length > 0" class="device-stress">
            <StressAlert v-for="(alert, idx_a) in alerts" :key="idx_a"
                        :queryHours="queryHours"
                        :alert="alert" :showType="showType"
                        :modalID="getModalID(idx_a, alert.status_code)"
                        :timezone="timezone"
                        :linkToDashboard="linkToDashboard" ></StressAlert>
        </div>
        <!--
        <div v-else class="device-stress">
            <div class="btn-stress stress_G001">
                <i :class="$tools.style.classStressIcon( 'G001', 'block-text' )"></i>{{ $t('stress.G001') }}
            </div>
        </div> -->
    </div>
</template>

<script>
// import TestData from '@/testData/testData'
import { mapState } from 'vuex'
import StressAlert from '@/views/components/StressAlert'

export default {
    props: {
        alertsData: {
            type: Object,
            //required: true,
        },
        timezone: { type: String },
        showType: {
            type: String,
            default: 'icon_text',
        },
        device: {
            type: Object,
        },
        project_id: {
            type: [String, Number],
            required: true,
        },
        cropperiod_id: {
            type: [String, Number],
            required: true,
        },
        linkToDashboard: {
            type: Boolean,
            default: true,
        },
        queryHours: {
            type: Number,
            default: 24,
        },
        autoRefresh: {
            type: Boolean,
            default: false,
        }
    },
    data ()
    {
        return {
            timer: '',
            autoUpdateMinutes: 5,

            cp_alertsData: {},

            // test
            // alertData_Test: TestData.alert_width_works.alerts,
        }
    },
    created ()
    {
        if (this.autoRefresh)
        {
            let _intervalTime = this.autoUpdateMinutes * 60 * 1000;
            this.timer = setInterval(this.getAlertsData_fromAPI, _intervalTime);
        }
    },
    mounted ()
    {
        this.initial_Query()
    },
    components: {
        StressAlert,
    },
    computed:
    {
        ...mapState({
            'language': state => state.user.language,
        }),

        alerts ()
        {
            if (this.cp_alertsData) return this.arrangeAlerts();
            else return [];
        },
    },
    watch: {

        // 當期作 id 改變時，重新抓取 Alerts Data
        cropperiod_id ()
        {
            // console.log('call alertsData api')
            if (this.alertsData == undefined) {
                this.getAlertsData_fromAPI();
            }
        },

        // 搜尋時間範圍改變時，重新抓取 Alerts Data
        queryHours ()
        {
            if (this.alertsData == undefined) {
                this.getAlertsData_fromAPI();
            }
        },

        // 偵測到 [ 語言 ] 變動就更新圖表
        language()
        {
            if (this.alertsData == undefined) {
                this.getAlertsData_fromAPI();
            }
        },

    },
    methods: {

        initial_Query ()
        {
            // 沒有傳入預警資訊就呼叫 API
            if (this.alertsData == undefined)
            {
                this.getAlertsData_fromAPI();
            }
            else
            {
                this.cp_alertsData = this.alertsData;
            }

            // test
            // this.cp_alertsData = this.alertData_Test;
        },

        lazy_handler ()
        {
            this.initial_Query()
        },

        getAlertsData_fromAPI ()
        {
            // console.log( 'get Alert by CropperiodID: ' + this.cropperiod_id )
            this.cp_alertsData = {};

            let querySettings = {
                cropperiodID: this.cropperiod_id,
                projectID: this.project_id,
                range: this.queryHours,  // 6, 12, 24 小時
            }
            this.$store.dispatch('cropperiod/getAlerts', querySettings)
            .then( res => {
                // console.log( res )
                this.cp_alertsData = res.alerts;
            })
            .catch( err => {
                // console.log( err )
            })

        },

        getDate (date)
        {
            return this.$tools.date.dateTimeZone(date, this.timezone, 'YYYY-MM-DD HH:mm');
        },

        getModalID (idx, status_code)
        {
            let _id = `${ this.project_id }-${ this.cropperiod_id }-`;
            if (this.device)
            {
                _id += `device-${ this.device.hashid }-`;
            }
            return _id += `${ idx }-${ status_code }`;
        },

        arrangeAlerts ()
        {
            let alertsData = {};
            let count_alerts = {};      // 統計分類用 Object 找 Key 比較快
            let arranged_alerts = [];   // 介面呈現用 Array 迴圈產生比較快

            // 【 EXAMPLE 】一個期作的 Alerts 格式
            // "alerts"= {
            //     "DBo07v0y": [
            //         { "status_code": "A003", "log_time": "2018-12-13 06:14:17" },
            //         { "status_code": "A003", "log_time": "2018-12-13 06:24:46" },
            //         { "status_code": "A003", "log_time": "2018-12-13 06:35:16" },
            //     ]
            // }

            // 如果有指定感測器，就只顯示該感測器的預警
            if (this.device)
            {
                alertsData[ this.device.hashid ] = this.cp_alertsData[ this.device.hashid ];
            }
            else alertsData = this.cp_alertsData;


            // 跑每個感測器的 alerts，並把 alert 依據 status_code(stress code) 做分類
            for (let _deviceKey in alertsData)
            {
                let _deviceAlerts = alertsData[ _deviceKey ]
                if (_deviceAlerts && _deviceAlerts.length > 0)
                {

                    _deviceAlerts.forEach( _alert => {
                        if ( count_alerts[ _alert.status_code ] == undefined )
                        {
                            count_alerts[ _alert.status_code ] = {
                                status_code: _alert.status_code,
                                project_id: this.project_id,
                                cropperiod_id: this.cropperiod_id,
                                log_info: [],
                                device: undefined,
                                name: undefined,
                                work: _alert.work,
                            }

                            // 當 autoRefresh 時，表示是 dashboard 頁面的感測器個別呼叫 alert，
                            // 所以可以保證 device, name 是同一個
                            if (this.autoRefresh)
                            {
                                count_alerts[ _alert.status_code ].device = _deviceKey;
                                count_alerts[ _alert.status_code ].name = _alert.name;
                            }
                        }
                        // 紀錄此 alert 是發生在哪個：時間、感測器ID
                        let _alert_info = {
                            log_time: this.getDate( _alert.log_time ),
                            device: _deviceKey,
                            name: _alert.name,
                        }
                        count_alerts[ _alert.status_code ].log_info.push( _alert_info );
                    })
                }
            }

            // 將剛剛統計完成的分類後的 alerts 改成 array 型態
            for (let _statusKey in count_alerts )
            {
                count_alerts[ _statusKey ].log_info.reverse();
                arranged_alerts.push( count_alerts[ _statusKey ] );
            }

            return arranged_alerts;
        },
    },
    beforeDestroy ()
    {
        // Cancel Auto Update
        if (this.autoRefresh)
        {
            clearInterval(this.timer)
        }
    }

}
</script>
